import { api } from '..';
export const deleteAllNotifications = user_id => {
  return api.firebase.deleteAllNotifications(user_id).then(response => Promise.resolve(response.data)).catch(e => Promise.reject(e.response));
};
export const getFirebaseToken = () => {
  return api.firebase.getToken().then(response => Promise.resolve(response.data)).catch(e => Promise.reject(e.response));
};